import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatRelative } from "@/lib/utils";
import { Activity as ActivityIcon } from "lucide-react";

const TYPE_COLOR = {
  pin_created: "var(--st-open)",
  pin_status_changed: "var(--st-assigned)",
  pin_assigned: "var(--st-assigned)",
  pin_commented: "var(--fop-text-2)",
  pin_photo_added: "var(--fop-text-2)",
  workflow_linked: "var(--fop-primary)",
  plan_set_uploaded: "var(--st-corrected)",
  sheet_uploaded: "var(--st-corrected)",
  project_created: "var(--st-progress)",
};

export default function ActivityPage() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/activities", { params: { limit: 100 } }).then((r) => setItems(r.data));
  }, []);

  return (
    <div className="p-8 max-w-3xl mx-auto" data-testid="activity-page">
      <div className="mb-6">
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[var(--fop-text-3)] mb-2">
          Activity Stream
        </div>
        <h1 className="font-display text-4xl text-[var(--fop-text)]">Operational memory</h1>
        <p className="text-[var(--fop-text-2)] mt-2">Every meaningful action across projects, sheets, pins, and workflows.</p>
      </div>

      {items.length === 0 ? (
        <div className="text-[var(--fop-text-3)] text-sm">No activity yet.</div>
      ) : (
        <ul className="space-y-0.5">
          {items.map((a) => (
            <li key={a.id} className="flex items-start gap-3 px-3 py-2.5 rounded-md hover:bg-[var(--fop-surface-2)] transition-colors">
              <div className="mt-1 w-2 h-2 rounded-full shrink-0" style={{ background: TYPE_COLOR[a.type] || "var(--fop-text-3)" }} />
              <div className="flex-1 min-w-0">
                <div className="text-sm text-[var(--fop-text)] leading-snug">{a.message}</div>
                <div className="text-[10px] uppercase font-mono tracking-wider text-[var(--fop-text-4)] mt-0.5">
                  {a.type.replace(/_/g, " ")} · {formatRelative(a.created_at)}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
